import React from 'react';
import { LeftOutline } from 'antd-mobile-icons';
import { Switch } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import { useReturnToWhsSettingsStore } from '../../../store/returnToWhsSettingsStore';

interface ReturnToWhsSettingsPageProps {
    onBack: () => void;
}

export const ReturnToWhsSettings: React.FC<ReturnToWhsSettingsPageProps> = ({ onBack }) => {
    const { t } = useTranslation();

    // 使用全局设置状态 - 类似于 PickupArrivalPage 使用 useBluetoothScaleStore
    const { 
        directAcceptDeliveryPackages, 
        directWarehouseEntry,
        setDirectAcceptDeliveryPackages,
        setDirectWarehouseEntry
    } = useReturnToWhsSettingsStore();

    return (
        <div className="w-full h-full flex flex-col bg-white">
            {/* Header */}
            <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
                <button 
                    onClick={onBack}
                    className="flex items-center justify-center w-8 h-8"
                >
                    <LeftOutline fontSize={20} color="#666" />
                </button>
                <span className="text-lg font-medium text-gray-900">
                    {t('pda.pages.returnToWhs.settings.title')}
                </span>
                <div className="w-8 h-8"></div> {/* 占位元素，保持布局平衡 */}
            </div>

            {/* Settings Content - 与 PickupArrivalPage 相同的背景和间距 */}
            <div className="flex-1 overflow-y-auto p-2 flex flex-col gap-2">
                {/* 第一个设置项 */}
                <div className="bg-white p-4 rounded">
                    <div className="flex justify-between items-center">
                        <span className="text-base font-medium">
                            {t('pda.pages.returnToWhs.settings.directAcceptDeliveryPackages')}
                        </span>
                        <Switch
                            checked={directAcceptDeliveryPackages}
                            onChange={setDirectAcceptDeliveryPackages}
                        />
                    </div>
                </div>

                {/* 第二个设置项 */}
                <div className="bg-white p-4 rounded">
                    <div className="flex justify-between items-center">
                        <span className="text-base font-medium">
                            {t('pda.pages.returnToWhs.settings.directWarehouseEntry')}
                        </span>
                        <Switch
                            checked={directWarehouseEntry}
                            onChange={setDirectWarehouseEntry}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
